import { render } from "./PhoneComponent.vue?vue&type=template&id=bde7b7f4&scoped=true"
import script from "./PhoneComponent.vue?vue&type=script&lang=js"
export * from "./PhoneComponent.vue?vue&type=script&lang=js"

import "./PhoneComponent.vue?vue&type=style&index=0&id=bde7b7f4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/talkvox_portal_v2/talkvox_portal_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde7b7f4"]])

export default __exports__